export const cycleCountRoutes = [
  {
    path: "/inventory/scan",
    name: "inventory-scan",
    component: () => import("@/views/CycleCount/CycleScan.vue"),
    meta: {
      title: "Inventory Count Cycle",
      ability: { action: "read", subject: "CycleCount" },
    },
  },
];
